<template>
  <div
    class="cookies-bg"
    v-if="isOpen"
  >
    <div class="cookies d-grid gap-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-12 col-lg-9 d-flex align-items-center">
          <img
            src="https://i0.wp.com/ntwsummit.com/wp-content/uploads/2025/07/NTW_SUMMIT_2025_4%40144x-8-1.png?fit=650%2C449&ssl=1"
            alt="NTW Summit 2025 Logo"
            class="event-logo"
          />
          <div class="text-content">
            <p
              class="message"
              v-html="$t('message.eventBanner.message')"
            />
            <p class="greeting">{{ $t('message.eventBanner.greeting') }}</p>
            <div class="countdown d-inline-flex align-items-center gap-2">
              <span>{{ $t('message.eventBanner.expiresIn') }}</span>
              <CountdownTimer @countdown-finished="handleCountdownFinished" />
            </div>
          </div>
        </div>
        <div
          class="col-12 col-lg-3 col-sm-12 d-flex flex-column flex-row gap-2 justify-content-center justify-content-md-end mt-4"
        >
          <CopyButton text-to-copy="QRRRVXLJ" />
          <button
            class="btn btn-gradient accept-cookies"
            @click="accept"
          >
            {{ $t('message.eventBanner.close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CopyButton from '@/components/CopyButton.vue'
import CountdownTimer from '@/components/CountdownTimer.vue'

export default {
  name: 'EventBanner',
  components: {
    CountdownTimer,
    CopyButton,
  },
  data() {
    return {
      isOpen: true,
    }
  },

  methods: {
    accept() {
      this.isOpen = false
    },
    handleCountdownFinished() {
      this.isOpen = false
    },
  },
}
</script>

<style scoped>
.cookies-bg {
  position: fixed;
  width: 100%;
  bottom: 1rem;
  z-index: 9999999;
}

.cookies-bg p {
  margin-bottom: 0px !important;
}

.cookies {
  background: var(--c5);
  padding: 14px;
  max-width: 80%;
  border-radius: 10px;
  margin: 0 auto;

  animation: slideUp 0.5s forwards;
  opacity: 0;
  transform: translateY(1rem);
}

@keyframes slideUp {
  to {
    transform: initial;
    opacity: initial;
  }
}

.event-logo {
  max-width: 100px;
}

.cookies .message {
  color: var(--c1);
  font-size: 1.1rem !important;
  text-align: left;
  font-weight: bold;
}

.highlight-blue {
  color: #64a5e6;
}

.cookies a {
  color: var(--color-primary);
  letter-spacing: 0;
  border-bottom: 1px solid transparent;
  font-weight: 600;
}
.cookies a:hover {
  border-bottom: 1px solid var(--color-primary);
}
.buttons {
  display: flex;
  gap: 24px;
}

.event-banner-grid {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 1rem;
  align-items: center;
}

.countdown {
  font-size: 0.875rem;
  color: var(--c1);
  margin-top: 0.5rem;
}

@media (min-width: 751px) {
  .cookies {
    padding: 20px;
    max-width: 80%;
  }
  .event-logo {
    max-width: 150px;
  }
  .cookies .message {
    font-size: 1.5rem !important;
  }
  .cookies .links {
    font-size: 1.25rem;
  }
}
</style>
